/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { PrayerTimeInterruptionModel } from '../models/prayerTimeInterruption';
import { InterruptionsModel } from '../models/interruptions';
import { AdInterruption } from '../models/AdInterruption';
import { props, createAction } from '@ngrx/store';

export enum InterruptionsActionTypes {
  Init = '[Interruptions] Init',

  CalculateTimeOffsets = '[Interruptions] Calculate Time Offsets',
  CalculateTimeOffsetsSuccess = '[Interruptions] Calculate Time Offsets Success',
  CalculateTimeOffsetsFailure = '[Interruptions] Calculate Time Offsets Failure',
  // Prayer Time actions
  LoadPrayerTimes = '[Interruptions] Load',
  LoadPrayerTimesSuccess = '[Interruptions] Load Success',
  LoadPrayerTimesFailure = '[Interruptions] Load Failure',

  LoadAds = '[Interruptions] Load Ads',
  LoadAdsSuccess = '[Interruptions] Load Ads Success',
  LoadAdsFailure = '[Interruptions] Load Ads Failure',

  SetTimers = '[Interruptions] Set Timers',
  SetTimersSuccess = '[Interruptions] Set Timers Success',
  SetTimersFailure = '[Interruptions] Set Timers Failure',

  NoAction = '[Interruptions] No Action',
  UnsetTimers = '[Interruptions] Unset Timers',

  PlayPrayerTimeSilence = '[Interruption] Play Silence',
  PlayPrayerTime = '[Interruption] Play Audio Source',
  StopPrayerTime = '[Interruption] Stop Prayer Time',

  PlayAd = '[Interruption] Play Ad',
  StopAd = '[Interruption] Stop Ad',

  StopAll = '[Interruption] Stop All',

  ResetPreviousMutedState = '[Interruption] Reset Previous Mute State',

  LoadNextInterruption = '[Interruption] Load Next',
  LoadNextInterruptionSuccess = '[Interruption] Load Next Success',
  LoadNextInterruptionFailure = '[Interruption] Load Next Failure',

  LoadInterruptions = '[Interruptions] Load',

  ReloadInterruptions = '[Interruptions] Reload',
  ReloadInterruptionsSuccess = '[Interruptions] Reload Success',
  ReloadInterruptionsFailure = '[Interruptions] Reload Failure',
}

export const Init = createAction(InterruptionsActionTypes.Init);
export const CalculateTimeOffsets = createAction(InterruptionsActionTypes.CalculateTimeOffsets);

export const CalculateTimeOffsetsSuccess = createAction(
  InterruptionsActionTypes.CalculateTimeOffsetsSuccess,
  props<{ localTimeOffset: number; timezoneOffset: number }>(),
);
export const CalculateTimeOffsetsFailure = createAction(InterruptionsActionTypes.CalculateTimeOffsetsFailure);
export const LoadPrayerTimes = createAction(InterruptionsActionTypes.LoadPrayerTimes);

export const LoadPrayerTimesSuccess = createAction(
  InterruptionsActionTypes.LoadPrayerTimesSuccess,
  props<{ prayerTimeInterruptions: PrayerTimeInterruptionModel[]; prayerTimeAudioSource: string }>(),
);
export const LoadPrayerTimesFailure = createAction(InterruptionsActionTypes.LoadPrayerTimesFailure);
export const LoadAds = createAction(InterruptionsActionTypes.LoadAds);
export const LoadAdsSuccess = createAction(InterruptionsActionTypes.LoadAdsSuccess, props<{ adInterruptions: AdInterruption[] }>());

export const LoadAdsFailure = createAction(InterruptionsActionTypes.LoadAdsFailure);
export const SetTimers = createAction(InterruptionsActionTypes.SetTimers);
export const SetTimersSuccess = createAction(InterruptionsActionTypes.SetTimersSuccess);
export const SetTimersFailure = createAction(InterruptionsActionTypes.SetTimersFailure);
export const NoAction = createAction(InterruptionsActionTypes.NoAction);
export const UnsetTimers = createAction(InterruptionsActionTypes.UnsetTimers);

export const PlayPrayerTimeSilence = createAction(InterruptionsActionTypes.PlayPrayerTimeSilence, props<{ previousMutedState: boolean }>());
export const PlayPrayerTime = createAction(InterruptionsActionTypes.PlayPrayerTime, props<{ previousMutedState: boolean }>());

export const StopPrayerTime = createAction(InterruptionsActionTypes.StopPrayerTime);
export const PlayAd = createAction(
  InterruptionsActionTypes.PlayAd,
  props<{ adInterruption: AdInterruption; previousMutedState: boolean }>(),
);

export const StopAd = createAction(InterruptionsActionTypes.StopAd);
export const StopAll = createAction(InterruptionsActionTypes.StopAll);
export const ResetPreviousMutedState = createAction(InterruptionsActionTypes.ResetPreviousMutedState);
export const LoadNextInterruption = createAction(InterruptionsActionTypes.LoadNextInterruption);

export const LoadNextInterruptionSuccess = createAction(
  InterruptionsActionTypes.LoadNextInterruptionSuccess,
  props<{ interruption: PrayerTimeInterruptionModel }>(),
);

export const LoadNextInterruptionFailure = createAction(InterruptionsActionTypes.LoadNextInterruptionFailure);

export const LoadInterruptions = createAction(InterruptionsActionTypes.LoadInterruptions, props<{ interruptions: InterruptionsModel }>());

export const ReloadInterruptions = createAction(InterruptionsActionTypes.ReloadInterruptions);
export const ReloadInterruptionsSuccess = createAction(InterruptionsActionTypes.ReloadInterruptionsSuccess);
export const ReloadInterruptionsFailure = createAction(InterruptionsActionTypes.ReloadInterruptionsFailure);
